import { useState } from "react";
import { Link } from "react-router-dom";

export default function FloatingActionButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col items-end gap-3">
      {/* Menu items */}
      <div
        className={`flex flex-col items-end gap-3 transition-all duration-300 ${
          isOpen
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        {/* FAQ */}
        <Link
          to="/faq"
          onClick={() => setIsOpen(false)}
          className="flex items-center gap-3 group"
        >
          <span className="text-white text-[0.875rem] font-medium bg-brand-black/90 border border-brand-border rounded-full px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">
            常見問題
          </span>
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-brand-card border border-brand-border text-brand-gold hover:border-brand-gold hover:bg-brand-black transition-colors shadow-lg">
            <i className="ri-questionnaire-line text-lg" />
          </span>
        </Link>

        {/* Contact */}
        <Link
          to="/contact"
          onClick={() => setIsOpen(false)}
          className="flex items-center gap-3 group"
        >
          <span className="text-white text-[0.875rem] font-medium bg-brand-black/90 border border-brand-border rounded-full px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">
            聯絡我們
          </span>
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-brand-card border border-brand-border text-brand-gold hover:border-brand-gold hover:bg-brand-black transition-colors shadow-lg">
            <i className="ri-mail-line text-lg" />
          </span>
        </Link>

        {/* LINE */}
        <a
          href="https://lin.ee/o51JBHX"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setIsOpen(false)}
          className="flex items-center gap-3 group"
        >
          <span className="text-white text-[0.875rem] font-medium bg-brand-black/90 border border-brand-border rounded-full px-4 py-2 opacity-0 group-hover:opacity-100 transition-opacity shadow-lg">
            加入 LINE
          </span>
          <span className="w-12 h-12 flex items-center justify-center rounded-full bg-brand-card border border-brand-border text-brand-gold hover:border-brand-gold hover:bg-brand-black transition-colors shadow-lg">
            <i className="ri-line-fill text-lg" />
          </span>
        </a>
      </div>

      {/* Main FAB Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 flex items-center justify-center rounded-full shadow-xl transition-all duration-300 cursor-pointer ${
          isOpen
            ? "bg-brand-card border border-brand-gold text-brand-gold rotate-45"
            : "bg-brand-gold text-brand-black hover:bg-brand-gold-soft"
        }`}
        aria-label="快速導航選單"
      >
        <i className="ri-add-line text-2xl" />
      </button>
    </div>
  );
}